<template>
  <div class="menu-bar-container">
    <!-- style="height: 100vh; position: absolute; top:60px;bottom: 0px;" -->
    <div class="left-menu">
      <!-- 注意需要给 el-scrollbar 设置高度，判断是否滚动是看它的height判断的 -->
      <el-scrollbar style="height: 100%;">
        <!-- 导航菜单 -->
        <el-menu
          ref="navmenu"
          default-active="1"
          :class="collapse ? 'menu-bar-collapse-width' : 'menu-bar-width'"
          :collapse="collapse"
          :collapse-transition="false"
          :unique-opened="true"
          :default-openeds="openeds"
          @open="handleopen"
          @close="handleclose"
          @select="handleselect"
        >
          <!-- 导航菜单树组件，动态加载菜单 -->
          <menu-tree
            v-for="item in navTree"
            :key="item.menuId"
            :menu="item"
          ></menu-tree>
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MenuTree from "@/components/MenuTree";
export default {
  name: "NavBar",
  components: {
    MenuTree
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      appName: state => state.app.appName,
      themeColor: state => state.app.themeColor,
      collapse: state => state.app.collapse,
      navTree: state => state.menu.navTree
    }),
    openeds: {
      get() {
        let ids = [];
        for (let index = 0; index < this.navTree.length; index++) {
          const item = this.navTree[index];
          ids.push(item.menuId + "");
        }
        //console.log("ids->", ids);
        return ids;
      }
    },
    mainTabs: {
      get() {
        return this.$store.state.tab.mainTabs;
      },
      set(val) {
        this.$store.commit("updateMainTabs", val);
      }
    },
    mainTabsActiveName: {
      get() {
        return this.$store.state.tab.mainTabsActiveName;
      },
      set(val) {
        this.$store.commit("updateMainTabsActiveName", val);
      }
    }
  },
  watch: {
    $route: "handleRoute"
  },
  created() {
    this.handleRoute(this.$route);
  },
  methods: {
    handleopen(index) {
      //console.log("handleopen");
      //console.log(index);
    },
    handleclose() {
      //console.log("handleclose");
    },
    handleselect(a, b) {
      //console.log("handleselect");
    },
    // 路由操作处理
    handleRoute(route) {
      // tab标签页选中, 如果不存在则先添加
      var tab = this.mainTabs.filter(item => item.name === route.name)[0];
      if (!tab) {
        tab = {
          name: route.name,
          title: route.name,
          icon: route.meta.icon
        };
        this.mainTabs = this.mainTabs.concat(tab);
      }
      this.mainTabsActiveName = tab.name;
      // 切换标签页时同步更新高亮菜单
      if (this.$refs.navmenu != null) {
        this.$refs.navmenu.activeIndex = "" + route.meta.index;
        this.$refs.navmenu.initOpenedMenu();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-bar-container {
  // position: fixed;
  top: 0px;
  left: 0;
  bottom: 0;
  z-index: 1020;
  .left-menu {
    position: absolute;
    top: 68px;
    bottom: 0px;
    width: 200px;
    text-align: left;
    border-right: solid 1px #e6e6e6;
    border-top: solid 1px #e6e6e6;
    list-style: none;
    height: 100vh -60px;
    // background-color: #ebeef5;
  }
  .el-menu {
    border-right: solid 0px;
    // background-color: #ebeef5;
  }
  .menu-bar-width {
    width: 200px;
  }
  .menu-bar-collapse-width {
    width: 65px;
  }
  .el-scrollbar >>> .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/NavBar.vue